import { useIsMutating, useMutation } from '@tanstack/react-query'

import { switchResources } from '@/features/resourceSwitchboard/endpoints/resourceSwitchboard'

const SWITCH_RESOURCES_API_ID = 'SWITCH_RESOURCES'

export function useSwitchResourcesMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (tsvRows: string) => switchResources(tsvRows),
    mutationKey: [SWITCH_RESOURCES_API_ID],
  })

  return {
    switchResources: mutateAsync,
    ...mutationResult,
  }
}

export const useIsSwitchingResources = (): boolean => useIsMutating({ mutationKey: [SWITCH_RESOURCES_API_ID] }) > 0
